import * as Yup from 'yup';
import { DB_PREFIX } from './constants';

export default Yup.object().shape({
  [DB_PREFIX]: Yup.object().shape({
    type: Yup.string().required(
      'Please select the type of service you provide'
    ),
    service: Yup.string().required('Please select a service'),
  }),
});
